import { Injectable } from '@angular/core';

import { filter, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import { ObjectClass } from '@app/common';


@Injectable({
  providedIn: 'root',
})
export class DrawerDataService {

  private _dataChanged$ = new Subject<{ objectClass: ObjectClass; data: any }>();
  private _dataDeleted$ = new Subject<{ objectClass: ObjectClass; data: any }>();

  public dataChanged(objectClass: ObjectClass): Observable<any> {
    return this._dataChanged$
      .pipe(
        filter((item) => {
          return item.objectClass === objectClass;
        }),
        map((item) => {
          return item.data;
        }),
      );
  }
  public dataDeleted(objectClass: ObjectClass): Observable<any> {
    return this._dataDeleted$
      .pipe(
        filter((item) => {
          return item.objectClass === objectClass;
        }),
        map((item) => {
          return item.data;
        }),
      );
  }

  public dataChange(objectClass: ObjectClass, data: any): void {
    this._dataChanged$.next({ objectClass, data });
  }

  public dataDelete(objectClass: ObjectClass, data: any): void {
    this._dataDeleted$.next({ objectClass, data });
  }

}
